import React from 'react'
import { useTranslation } from 'react-i18next'
import secureBadgeImg from 'assets/images/secure-badge.png'
import { StyledSecurityInfo as S } from './SecurityInfo.styles'

type TProps = {
  className?: string
}

export const SecurityInfo: React.FC<TProps> = ({ className }) => {
  const { t } = useTranslation()

  return (
    <S.Wrapper className={className}>
      <S.SecureBadge>
        <S.Image src={secureBadgeImg} height={40} alt="Secure badge" />
      </S.SecureBadge>
      <S.Title>{t`purchase.securityInfo.titleFirst`}</S.Title>
      <S.Text>{t`purchase.securityInfo.textFirst`}</S.Text>
      <S.Title>{t`purchase.securityInfo.titleSecond`}</S.Title>
      <S.Text>{t`purchase.securityInfo.textSecond`}</S.Text>
      <S.Title>{t`purchase.securityInfo.titleThird`}</S.Title>
      <S.Text>
        {t`purchase.securityInfo.textThird`}{' '}
        <a href="mailto:support@harmonybit.com">support@harmonybit.com</a>
      </S.Text>
    </S.Wrapper>
  )
}
